import { graphql, useStaticQuery } from 'gatsby';
import GeneralPageTemplate from "@/components/template/generalPageTemplate";
import { PagoCreditosLibranzasTemplate } from "@/components/template/libranzas/pagoCreditosLibranzasTemplate";

const PagoCreditosLibranzasPage = () => {
    const query = useStaticQuery(graphql`
        query GET_PAGOS_LIBRANZAS_COMBINED {
            pagosLibranzas: allContentfulTemplate(
                filter: {titulo: {eq: "Interna de pagos > Consulta pago libranza"}}
            ) {
                nodes {
                    metaInfo {
                        metaTitulo
                        metaDescripcion
                        metaImagen {
                            file {
                                url
                            }
                        }
                        urlCanonical
                        noIndex
                    }
                    estaActivo
                    migaDePan
                    titulo
                    nombre
                    subtitulo
                    serviceId
                    interrogationDescription {
                        raw
                    }
                    referencias {
                        ... on ContentfulTemplate {
                            nombre
                            subtitulo
                            lista
                            boton {
                                copy
                                redireccion
                            }
                            interrogationDescription {
                                raw
                            }
                        }
                    }
                    imagen {
                        title
                        file {
                            url
                        }
                    }
                    descripcion {
                        raw
                    }
                }
            }
            pagosLibranzasRealizados: allContentfulTemplate(
                filter: {titulo: {eq: "Interna de pagos > Consulta pago libranza detalle"}}
            ) {
                nodes {
                    estaActivo
                    migaDePan
                    titulo
                    nombre
                    imagen {
                        title
                        file {
                            url
                        }
                    }
                    descripcion {
                        raw
                    }
                }
            }
        }
    `);

    const content = query?.pagosLibranzas?.nodes[0];
    const queryData = { allContentfulTemplate: query.pagosLibranzas };
    const queryDataRealizados = { allContentfulTemplate: query.pagosLibranzasRealizados };

    return (
        <GeneralPageTemplate
            data={content?.metaInfo[0]}
            hasLoader={true}
            isPrivate={true}
            isActive={content?.estaActivo}
            serviceId={content?.serviceId}
        >
            <PagoCreditosLibranzasTemplate
                queryData={queryData}
                queryDataRealizados={queryDataRealizados}
            />
        </GeneralPageTemplate>
    );
};

export default PagoCreditosLibranzasPage;